jQuery.noConflict();
jQuery(document).ready(function(){ 
  if( $('.featuredprojets').length > 0 ) {
    $('.featuredprojets_elements').owlCarousel({
      nav: true,
      navText: ["<span class='arrow-previous'>","<span class='arrow-next'>"],
      autoplay: true,
      autoplayTimeout: 6000,
      autoplayHoverPause: true,
      mouseDrag: false,
      touchDrag: false,
      dots: true,
      loop: true,
      items: 1,
    })
  }
});
